var $ = require('jquery')
  , setupHandleAnchorLinkClicked =
      require('shouyou/widgets/setupHandleAnchorLinkClicked')

$(function() {
  if($('.js-tab').length>0){
    $(".js-tab").each(function() {
      $(".tab:eq(0)", $(this)).tabs($(".tab-pn:eq(0) > div", $(this)), {
        event: 'click'
      });
    });
  };

  var pandora = window.pandora

  if (pandora && $('.share-box').length) {
    pandora.use(['share'], function(Share) {
      new Share({
        element: '.share-box',
        shareList: 'weixin,qq,qzone,tsina',
        showLabel: false,
        importStyle: false,
        customShare : {
          weixin : {
            position : 'left'
          }
        }
      });
    });
  }

  var $backToTopEle = $('.bt-to-top').click(function() {
    $("html, body").animate({
      scrollTop: 0
    }, 120);
  }),
  $backToTopFun = function() {
    var st = $(document).scrollTop(),
      winh = $(window).height();
    if(st > 0){
      $backToTopEle.css('display','block');
    }else{
      $backToTopEle.css('display','none');
    };
  };
  $(window).bind("scroll", $backToTopFun);


  setupHandleAnchorLinkClicked({ topbarHeight: 45 })
})
